import React from 'react';

export default function ProductLineBreakdown({ tabledata }) {
    // console.log(tabledata?.MTD?.["ILMCV Trucks"]?.MTD_C0_SUM?.value, "DATA")
    const scvmtd1 = tabledata?.MTD?.["SCV & PU"]?.MTD_C0_SUM?.value ?? 0
    const scvc1 = tabledata?.MTD?.["SCV & PU"]?.MTD_C1_SUM?.value ?? 0
    const scvc1a = tabledata?.MTD?.["SCV & PU"]?.MTD_C1A_SUM?.value ?? 0
    const scvc2 = tabledata?.MTD?.["SCV & PU"]?.MTD_C2_SUM?.value ?? 0
    const ilmc0 = tabledata?.MTD?.["ILMCV Trucks"]?.MTD_C0_SUM?.value ?? 0
    const ilmc1 = tabledata?.MTD?.["ILMCV Trucks"]?.MTD_C1_SUM?.value ?? 0
    const ilmc1a = tabledata?.MTD?.["ILMCV Trucks"]?.MTD_C1A_SUM?.value ?? 0
    const ilmc2 = tabledata?.MTD?.["ILMCV Trucks"]?.MTD_C2_SUM?.value ?? 0

    const hcvc0 = tabledata?.MTD?.["HCV Trucks"]?.MTD_C0_SUM?.value ?? 0
    const hcvc1 = tabledata?.MTD?.["HCV Trucks"]?.MTD_C1_SUM?.value ?? 0
    const hcvc1a = tabledata?.MTD?.["HCV Trucks"]?.MTD_C1A_SUM?.value ?? 0
    const hcvc2 = tabledata?.MTD?.["HCV Trucks"]?.MTD_C2_SUM?.value ?? 0
    const cvpc0 = tabledata?.MTD?.["CV Passenger"]?.MTD_C0_SUM?.value ?? 0
    const cvpc1 = tabledata?.MTD?.["CV Passenger"]?.MTD_C1_SUM?.value ?? 0
    const cvpc1a = tabledata?.MTD?.["CV Passenger"]?.MTD_C1A_SUM?.value ?? 0
    const cvpc2 = tabledata?.MTD?.["CV Passenger"]?.MTD_C2_SUM?.value ?? 0

    const scvcarryco = tabledata?.CARRYOVER?.["SCV & PU"]?.CARRYOVER_C0_SUM?.value ?? 0
    const scvcarryc1 = tabledata?.CARRYOVER?.["SCV & PU"]?.CARRYOVER_C1_SUM?.value ?? 0
    const scvcarryc1a = tabledata?.CARRYOVER?.["SCV & PU"]?.CARRYOVER_C1A_SUM?.value ?? 0
    const scvcarryc2 = tabledata?.CARRYOVER?.["SCV & PU"]?.CARRYOVER_C2_SUM?.value ?? 0

    const ilmcvcarryco = tabledata?.CARRYOVER?.["ILMCV Trucks"]?.CARRYOVER_C0_SUM?.value ?? 0
    const ilmcvcarryc1 = tabledata?.CARRYOVER?.["ILMCV Trucks"]?.CARRYOVER_C1_SUM?.value ?? 0
    const ilmcvcarryc1a = tabledata?.CARRYOVER?.["ILMCV Trucks"]?.CARRYOVER_C1A_SUM?.value ?? 0
    const ilmcvcarryco2 = tabledata?.CARRYOVER?.["ILMCV Trucks"]?.CARRYOVER_C2_SUM?.value ?? 0

    const hcvcarryco = tabledata?.CARRYOVER?.["HCV Trucks"]?.CARRYOVER_C0_SUM?.value ?? 0
    const hcvcarryc1 = tabledata?.CARRYOVER?.["HCV Trucks"]?.CARRYOVER_C1_SUM?.value ?? 0
    const hcvcarryc1a = tabledata?.CARRYOVER?.["HCV Trucks"]?.CARRYOVER_C1A_SUM?.value ?? 0
    const hcvcarryco2 = tabledata?.CARRYOVER?.["HCV Trucks"]?.CARRYOVER_C2_SUM?.value ?? 0

    const cvcarryco = tabledata?.CARRYOVER?.["CV Passenger"]?.CARRYOVER_C0_SUM?.value ?? 0
    const cvcarryc1 = tabledata?.CARRYOVER?.["CV Passenger"]?.CARRYOVER_C1_SUM?.value ?? 0
    const cvcarryc1a = tabledata?.CARRYOVER?.["CV Passenger"]?.CARRYOVER_C1A_SUM?.value ?? 0
    const cvcarryco2 = tabledata?.CARRYOVER?.["CV Passenger"]?.CARRYOVER_C2_SUM?.value ?? 0

    const tqpcv = tabledata?.TOTAL?.["CV Passenger"]?.TQP_SUM?.value ?? 0
    const tqphcv = tabledata?.TOTAL?.["HCV Trucks"]?.TQP_SUM?.value ?? 0
    const tqpscv = tabledata?.TOTAL?.["SCV & PU"]?.TQP_SUM?.value ?? 0
    const tqpilmcv = tabledata?.TOTAL?.["ILMCV Trucks"]?.TQP_SUM?.value ?? 0


    const totalcvco = tabledata?.TOTAL?.["CV Passenger"]?.TOTAL_C0_SUM?.value ?? 0
    const totalcvc1 = tabledata?.TOTAL?.["CV Passenger"]?.TOTAL_C1_SUM?.value ?? 0
    const totalcvc2 = tabledata?.TOTAL?.["CV Passenger"]?.TOTAL_C2_SUM?.value ?? 0
    const totalcvc1a = tabledata?.TOTAL?.["CV Passenger"]?.TOTAL_C1A_SUM?.value ?? 0

    const totalhcvco = tabledata?.TOTAL?.["HCV Trucks"]?.TOTAL_C0_SUM?.value ?? 0
    const totalhcvc1 = tabledata?.TOTAL?.["HCV Trucks"]?.TOTAL_C1_SUM?.value ?? 0
    const totalhcvc2 = tabledata?.TOTAL?.["HCV Trucks"]?.TOTAL_C2_SUM?.value ?? 0
    const totalhcvc1a = tabledata?.TOTAL?.["HCV Trucks"]?.TOTAL_C1A_SUM?.value ?? 0

    const totalilmcvco = tabledata?.TOTAL?.["ILMCV Trucks"]?.TOTAL_C0_SUM?.value ?? 0
    const totalilmcvc1 = tabledata?.TOTAL?.["ILMCV Trucks"]?.TOTAL_C1_SUM?.value ?? 0
    const totalilmc2 = tabledata?.TOTAL?.["ILMCV Trucks"]?.TOTAL_C2_SUM?.value ?? 0
    const totalilmc1a = tabledata?.TOTAL?.["ILMCV Trucks"]?.TOTAL_C1A_SUM?.value ?? 0

    const totalscvco = tabledata?.TOTAL?.["SCV & PU"]?.TOTAL_C0_SUM?.value ?? 0
    const totalscvc1 = tabledata?.TOTAL?.["SCV & PU"]?.TOTAL_C1_SUM?.value ?? 0
    const totalscvc2 = tabledata?.TOTAL?.["SCV & PU"]?.TOTAL_C2_SUM?.value ?? 0
    const totalscvc1a = tabledata?.TOTAL?.["SCV & PU"]?.TOTAL_C1A_SUM?.value ?? 0

    const plData = [
        { name: "HCV Trucks", tqp: tqphcv, co: [hcvcarryco, hcvcarryc1, hcvcarryc1a, hcvcarryco2], mtd: [hcvc0, hcvc1, hcvc1a, hcvc2], total: [totalhcvco, totalhcvc1, totalhcvc1a, totalhcvc2] },
        { name: "ILMCV", tqp: tqpilmcv, co: [ilmcvcarryco, ilmcvcarryc1, ilmcvcarryc1a, ilmcvcarryco2], mtd: [ilmc0, ilmc1, ilmc1a, ilmc2], total: [totalilmcvco, totalilmcvc1, totalilmc1a, totalilmc2] },
        { name: "CV Passenger", tqp: tqpcv, co: [cvcarryco, cvcarryc1, cvcarryc1a, cvcarryco2], mtd: [cvpc0, cvpc1, cvpc1a, cvpc2], total: [totalcvco, totalcvc1, totalcvc1a, totalcvc2] },
        { name: "SCV & PU", tqp: tqpscv, co: [scvcarryco, scvcarryc1, scvcarryc1a, scvcarryc2], mtd: [scvmtd1, scvc1, scvc1a, scvc2], total: [totalscvco, totalscvc1, totalscvc1a, totalscvc2] },
    ];

    const stages = ['C0', 'C1', 'C1A', 'C2'];

    // Grand Total calculations
    const grandTotalTQP = tqpcv + tqphcv + tqpilmcv + tqpscv;

    const grandTotalCo = [0, 1, 2, 3].map(i =>
        plData.reduce((sum, pl) => sum + (pl.co[i] ?? 0), 0)
    );
    const grandTotalMtd = [0, 1, 2, 3].map(i =>
        plData.reduce((sum, pl) => sum + (pl.mtd[i] ?? 0), 0)
    );
    const grandTotal = [0, 1, 2, 3].map(i =>
        plData.reduce((sum, pl) => sum + (pl.total[i] ?? 0), 0)
    );

    const LayersIcon = () => (
        <svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
            <polygon points="12 2 2 7 12 12 22 7 12 2" />
            <polyline points="2 17 12 22 22 17" />
            <polyline points="2 12 12 17 22 12" />
        </svg>
    );

    return (
        <div
            id="productLineSection"
            className="flex flex-col w-[400px] md:w-full bg-[#f8fafc] p-4 md:p-1 font-sans"
        >            <style>{`
        .custom-scrollbar::-webkit-scrollbar { width: 6px; height: 6px; }
        .custom-scrollbar::-webkit-scrollbar-track { background: transparent; border-radius: 4px; }
        .custom-scrollbar::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover { background: #94a3b8; }
      `}</style>

            <div className="bg-white rounded-xl shadow-sm border border-slate-200/80 w-full max-w-[2400px] ">

                {/* <div className="px-2 mb-4 flex items-center justify-between">
                    <h3 className="text-[12px] font-bold text-slate-500 uppercase tracking-widest">Product Line Breakdown (Comparison)</h3>
                </div> */}

                <div className=" pb-2">
                    <div className="overflow-x-auto custom-scrollbar border border-slate-200/80 rounded-lg shadow-sm bg-white">
                        <table
                            id="productLineTable"
                            className="w-full min-w-max border-collapse"
                        >                            <thead>
                                <tr className="bg-[#234b63] text-white">
                                    <th className="px-4 py-2.5 text-left text-[13px] font-semibold border-b border-[#1e3a4c] sticky left-0 bg-[#234b63] z-10">Product Line</th>
                                    <th className="px-3 py-2.5 text-center text-[13px] font-semibold border-b border-[#1e3a4c] border-l border-[#315d7a]">TQP</th>
                                    {stages.map(stage => (
                                        <th key={stage} className="px-3 py-2.5 text-center text-[13px] font-semibold border-b border-[#1e3a4c] border-l border-[#315d7a]">
                                            {stage} Stage
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {plData.map((pl, idx) => (
                                    <tr key={idx} className="hover:bg-slate-50 border-b border-slate-100 last:border-0 transition-colors group">
                                        <td className="px-4 py-3 text-left font-bold text-[#1e3a4c] text-[13px] sticky left-0 bg-white group-hover:bg-slate-50 shadow-[2px_0_5px_-2px_rgba(0,0,0,0.05)] z-10 transition-colors">
                                            <div className="flex items-center gap-2.5">
                                                <div className="w-6 h-6 rounded bg-[#f0f6fa] flex items-center justify-center flex-shrink-0">
                                                    <div className="text-[#245c81]"><LayersIcon /></div>
                                                </div>
                                                <span className="whitespace-nowrap">{pl.name}</span>
                                            </div>
                                        </td>
                                        <td className="px-3 py-3 text-center border-l border-slate-100 bg-[#f8fafc] group-hover:bg-[#f1f5f9] transition-colors">
                                            <span className="font-black text-[#245c81] text-[15px] bg-[#e3eff7] px-2.5 py-1 rounded border border-[#cce0ef] shadow-sm">
                                                {pl.tqp}
                                            </span>
                                        </td>
                                        {pl.total.map((totalVal, i) => (
                                            <td key={i} className="px-3 py-3 text-center border-l border-slate-100">
                                                <div className="flex flex-col items-center gap-1.5">
                                                    <span className="text-[14px] font-black text-slate-800 leading-none">
                                                        <span className="text-slate-500 font-bold text-[11px] mr-1">Total -</span>
                                                        {totalVal}
                                                    </span>
                                                    <div className="flex items-center gap-1.5 text-[10px] font-bold text-slate-500 bg-white px-1.5 py-0.5 rounded border border-slate-200 shadow-sm whitespace-nowrap">
                                                        <span title="Carryover">C/o: <span className="text-slate-700">{pl.co[i]}</span></span>
                                                        <span className="text-slate-300">|</span>
                                                        <span title="MTD" className={pl.mtd[i] > 0 ? "text-[#0173b2]" : ""}>
                                                            MTD: <span className={pl.mtd[i] > 0 ? "text-[#0173b2]" : "text-slate-700"}>{pl.mtd[i]}</span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>
                                        ))}
                                    </tr>
                                ))}

                                {/* Grand Total Row */}
                                <tr className="bg-[#1a3a4f] text-white border-t-2 border-[#0f2535]">
                                    <td className="px-4 py-3 text-left sticky left-0 bg-[#1a3a4f] z-10 shadow-[2px_0_5px_-2px_rgba(0,0,0,0.2)]">
                                        <div className="flex items-center gap-2.5">
                                            {/* <div className="w-6 h-6 rounded bg-[#245c81] flex items-center justify-center flex-shrink-0">
                                                <svg viewBox="0 0 24 24" width="14" height="14" stroke="white" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                                    <line x1="12" y1="5" x2="12" y2="19" />
                                                    <line x1="5" y1="12" x2="19" y2="12" />
                                                </svg>
                                            </div> */}
                                            <span className="text-[13px] font-black uppercase tracking-wide whitespace-nowrap text-white">Grand Total</span>
                                        </div>
                                    </td>

                                    {/* Grand Total TQP */}
                                    <td className="px-3 py-3 text-center border-l border-[#2a5570]">
                                        <span className="font-black text-white text-[15px] bg-[#245c81] px-2.5 py-1 rounded border border-[#1e4d6e] shadow-sm">
                                            {grandTotalTQP}
                                        </span>
                                    </td>

                                    {/* Grand Total Stage Columns */}
                                    {grandTotal.map((totalVal, i) => (
                                        <td key={i} className="px-3 py-3 text-center border-l border-[#2a5570]">
                                            <div className="flex flex-col items-center gap-1.5">

                                                <span className="text-[14px] font-black text-white leading-none">
                                                    <span className="text-blue-200 font-bold text-[11px] mr-1">
                                                        Total -
                                                    </span>
                                                    {totalVal}
                                                </span>

                                                <div className="flex items-center gap-1.5 text-[10px] font-bold text-white bg-[#245c81] px-1.5 py-0.5 rounded border border-[#1e4d6e] shadow-sm whitespace-nowrap">

                                                    <span>
                                                        C/o:
                                                        <span className="ml-1">
                                                            {grandTotalCo[i]}
                                                        </span>
                                                    </span>

                                                    <span className="text-blue-200">|</span>

                                                    <span>
                                                        MTD:
                                                        <span className="ml-1">
                                                            {grandTotalMtd[i]}
                                                        </span>
                                                    </span>

                                                </div>

                                            </div>
                                        </td>
                                    ))}
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}
